import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { LoginComponent } from './pages/login/login.component';
import { AccountRoutingModule } from './account-routing.module';
import { MyAccountComponent } from './pages/my-account/my-account.component';
import { AccountService } from '../core/services/account.service';
import { CreateAccountComponent } from './pages/create-account/create-account.component';
import { OrderHistoryComponent } from './pages/my-account/order-history/order-history.component';
import { OrderDetailsComponent } from './pages/order-details/order-details.component';
import { EditAddressComponent } from './pages/edit-address/edit-address.component';
import { SearchChildAccountComponent } from './pages/my-account/search-child-account/search-child-account.component';

import { ActivateAccountComponent } from './pages/activate-account/activate-account.component';
import { ChangePasswordComponent } from './pages/change-password/change-password.component';
import { NotificationSettingsComponent } from './pages/notification-settings/notification-settings.component';
import { MyProductsComponent } from './pages/my-account/my-products/my-products.component';

import { SharedModule } from '../shared/shared.module';
import { ForgotPasswordComponent } from './pages/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './pages/reset-password/reset-password.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ApplyScholarshipComponent } from './pages/apply-scholarship/apply-scholarship.component';
import { ServiceTermComponent } from './pages/service-term/service-term.component';

import { MyTestRegistrationComponent } from './pages/my-account/my-test-registration/my-test-registration.component';
import { TestActionsComponent } from './pages/my-account/test-actions/test-actions.component';
import { ActionHelper } from './pages/my-account/action.helper';

import { RedeemProductCodeComponent } from './pages/redeem-product-code/redeem-product-code.component';
import { PretestDiscountRequestComponent } from './pages/pretest-discount-request/pretest-discount-request.component';
import { BusinessAccountFormComponent } from './components/business-account-form/business-account-form.component';
import { EditBusinessAccountInfoComponent } from './pages/business-account/edit-business-account-info/edit-business-account-info.component';
import { ApplyBusinessAccountComponent } from './pages/business-account/apply-business-account/apply-business-account.component';
import { ApplyBusinessAccountCompleteComponent } from './pages/business-account/apply-business-account-complete/apply-business-account-complete.component';
import { SurveyFormComponent } from './components/survey-form/survey-form.component';

import { ScoreReportOptionsComponent } from './pages/score-report-options/score-report-options.component';
import { ScorePreferencesInstitutionComponent } from './components/score-preferences-institution/score-preferences-institution.component';
import { CheckScoreComponent } from './pages/check-score/check-score.component';


import { AffiliateDashboardComponent } from './pages/affiliate-dashboard/affiliate-dashboard.component';
import { ChartsModule } from 'ng2-charts';
import { LinkCreateComponent } from './pages/link-create/link-create.component';
import { AffiliateReportComponent } from './pages/affiliate-report/affiliate-report.component';
import { TypeaheadFocusComponent } from './components/typeahead-focus/typeahead-focus.component';
import { NgbDropdownModule, NgbTypeaheadModule } from '@ng-bootstrap/ng-bootstrap';
import { InvoicesComponent } from './pages/invoices/invoices.component';
import { UserOrdersByInvoiceComponent } from './pages/user-orders-by-invoice/user-orders-by-invoice.component';
import { OrderHardcopyScoreServiceComponent } from './pages/order-hardcopy-score-service/order-hardcopy-score-service.component';
import { UpcomingTestComponent } from './pages/my-account/upcoming-test/upcoming-test.component';
import { CreateChildAccountComponent } from './pages/business-account/create-child-account/create-child-account.component';
import { EditChildPersonalInfoComponent } from './pages/business-account/edit-child-personal-info/edit-child-personal-info.component';
import { ConfigureNotificationsComponent } from './pages/business-account/configure-notifications/configure-notifications.component';
import { BusinessAccountInfoComponent } from './pages/my-account/business-account-info/business-account-info.component';
import { AdoptChildAccountComponent } from './pages/adopt-child-account/adopt-child-account.component';
import { AccountAcceptAdoptionComponent } from './pages/account-accept-adoption/account-accept-adoption.component';
import { AccountAdoptionCompleteComponent } from './pages/account-adoption-complete/account-adoption-complete.component';
import { ConfirmModalComponent } from './components/confirm-modal/confirm-modal.component';
import { OrderTestReEvaluationComponent } from './pages/order-test-re-evaluation/order-test-re-evaluation.component';
import { OrderOneSkillRetakeComponent } from './pages/order-one-skill-retake/order-one-skill-retake.component';
import { SuperSigninComponent } from './pages/super-signin/super-signin.component';
import { ProofOfIdentityComponent } from './components/proof-of-identity/proof-of-identity.component';
import { TransferRegistrationComponent } from './pages/transfer-registration/transfer-registration.component';
import { ListClientRegistrationsComponent } from './pages/business-account/list-client-registrations/list-client-registrations.component';
import { PrepAudioFilesComponent } from './pages/prep-audio-files/prep-audio-files.component';
import { CancelRegistrationComponent } from './pages/cancel-registration/cancel-registration.component';
import { ReceivingInstitutionsComponent } from './pages/receiving-institutions/receiving-institutions.component';
import { StartMyTestComponent } from './pages/my-account/start-my-test/start-my-test.component';
import { ReloadScannedDocumentComponent } from './pages/my-account/reload-scanned-document/reload-scanned-document.component';
import { BiometricConsentComponent } from './pages/biometric-consent/biometric-consent.component';
import { CookiesNotificationComponent } from './components/cookies-notification/cookies-notification.component';
import { FeatureListComponent } from './components/feature-list/feature-list.component';
import { ScoreReportOptionsSelectorComponent } from './pages/score-report-options/score-report-options-selector/score-report-options-selector.component';
import { WebDeliveryActionsComponent } from './pages/web-delivery-actions/web-delivery-actions.component';
import { WebDeliveryComponent } from './components/web-delivery/web-delivery.component';
import { BusinessResourcesComponent } from './pages/business-account/business-resources/business-resources.component';
import { OrderHardcopyScoreServiceCaelComponent } from './pages/score-report-options/order-hardcopy-score-service-cael/order-hardcopy-score-service-cael.component';
import { TestTakerComplaintComponent } from './pages/test-taker-complaint/test-taker-complaint.component';


@NgModule({
  declarations: [
    LoginComponent,
    MyAccountComponent,
    CreateAccountComponent,
    OrderHistoryComponent,
    OrderDetailsComponent,
    EditAddressComponent,
    ActivateAccountComponent,
    ChangePasswordComponent,
    NotificationSettingsComponent,
    MyProductsComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    ApplyScholarshipComponent,
    ServiceTermComponent,
    RedeemProductCodeComponent,
    ScoreReportOptionsComponent,
    ScorePreferencesInstitutionComponent,
    MyTestRegistrationComponent,
    TestActionsComponent,
    PretestDiscountRequestComponent,
    BusinessAccountFormComponent,
    EditBusinessAccountInfoComponent,
    ApplyBusinessAccountComponent,
    ApplyBusinessAccountCompleteComponent,
    SurveyFormComponent,
    CheckScoreComponent,
    AffiliateDashboardComponent,
    LinkCreateComponent,
    AffiliateReportComponent,
    TypeaheadFocusComponent,
    InvoicesComponent,
    UserOrdersByInvoiceComponent,
    OrderHardcopyScoreServiceComponent,
    UpcomingTestComponent,
    CreateChildAccountComponent,
    EditChildPersonalInfoComponent,
    ConfigureNotificationsComponent,
    BusinessAccountInfoComponent,
    AdoptChildAccountComponent,
    AccountAcceptAdoptionComponent,
    AccountAdoptionCompleteComponent,
    SearchChildAccountComponent,
    ConfirmModalComponent,
    OrderTestReEvaluationComponent,
    OrderOneSkillRetakeComponent,
    SuperSigninComponent,
    ProofOfIdentityComponent,
    TransferRegistrationComponent,
    ListClientRegistrationsComponent,
    PrepAudioFilesComponent,
    CancelRegistrationComponent,
    ReceivingInstitutionsComponent,
    StartMyTestComponent,
    ReloadScannedDocumentComponent,
    BiometricConsentComponent,
    CookiesNotificationComponent,
    FeatureListComponent,
    ScoreReportOptionsSelectorComponent,
    WebDeliveryActionsComponent,
    WebDeliveryComponent,
    BusinessResourcesComponent,
    OrderHardcopyScoreServiceCaelComponent,
    TestTakerComplaintComponent
  ],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    AccountRoutingModule,
    SharedModule,
    NgbModule,
    BrowserAnimationsModule,
    ChartsModule,
    NgbTypeaheadModule,
    NgbDropdownModule,
  ],
  exports: [
    ScorePreferencesInstitutionComponent,
    ScoreReportOptionsSelectorComponent
  ],
  providers: [
    AccountService,
    ActionHelper
  ]
})
export class AccountModule { }
